export const PAYONEER_GET_EMPLOYEE_BALANCE = "PAYONEER_GET_EMPLOYEE_BALANCE";
export const PAYONEER_SET_EMPLOYEE_BALANCE = "PAYONEER_SET_EMPLOYEE_BALANCE";
export const PAYONEER_RESET_EMPLOYEE_BALANCE = "PAYONEER_RESET_EMPLOYEE_BALANCE";
export const PAYONEER_GET_EMPLOYEE_BALANCE_FAILED = "PAYONEER_GET_EMPLOYEE_BALANCE_FAILED";
